module.exports = __webpack_public_path__ + "img/overtime-empty-img.d175d33f.webp";